import CardInfo, { CardInfoProps } from './CardInfo';

export type { CardInfoProps };
export default CardInfo;
